import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'jhi-custom-alert-modal',
  templateUrl: './custom-alert-modal.component.html',
  styleUrls: ['./custom-alert-modal.component.scss']
})
export class CustomAlertModalComponent implements OnInit {

  @Input() public cModalTitle="";
  @Input() public cModalBody="";
  constructor(public activeModal: NgbActiveModal) {
    // do nothing
   }

  ngOnInit(): void {
    const temp="alertModel"
  }

}
